import { Formik } from "formik";
import { useSelector } from "react-redux";
import { Fragment, useState } from "react";
import { Paper, Stack } from "@mui/material";
import { Button, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, VerifiedUser } from "@mui/icons-material";

import Form from "./Form";
import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import { OuterBox } from "../../components";

const AutoGateOpen = () => {
  const axios = useAxios();
  const navigate = useNavigate();

  const { visitorData } = useSelector((state) => state.memberDetails);

  const localStorageData = { ...localStorage };

  const [closeQR, setQRClose] = useState(false);
  const [hotelData, setHotelData] = useState({ id: "", hotelID: "" });

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return (
      item.includes(visitorData.ID) ||
      (item.includes(visitorData.ID) && item.includes("face&docs"))
    );
  });

  const [formData, setFormData] = useState({
    QRCode: "",
  });

  return (
    <OuterBox>
      <Fragment>
        {!digipassDataKey[0] ? (
          <Fragment>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f1f9ff",
                borderLeft: "5px solid #1976d2",
                mt: 2,
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <VerifiedUser color="primary" />
                <Typography variant="body1" fontWeight={500}>
                  Kindly complete your profile verification — Face or Document
                  required.
                </Typography>
              </Stack>

              <Button
                variant="contained"
                size="medium"
                onClick={() => navigate(pages.Profile.route)}
                sx={{ textTransform: "capitalize", ml: 2 }}
              >
                Verify Now
              </Button>
            </Paper>
          </Fragment>
        ) : (
          <Formik
            initialValues={formData}
            onSubmit={(formData, { setSubmitting, resetForm }) => {
              let localStorageData = localStorage;

              let docs = {};
              Object.keys(localStorage).forEach((item) => {
                if (item.includes(visitorData.ID)) {
                  docs = localStorageData.getItem(item);
                }
              });

              axios({
                url: "entry/entry/open-gate",
                method: "POST",
                data: {
                  face_data: formData.ImgData,
                  verified_creds: docs,
                  machine_id: formData.QRCode,
                  gate_type: "open_gate",
                  visitor_id: visitorData.ID,
                },
                customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
              })
                .then((response) => {
                  if (response.status) {
                    setQRClose(true);
                  }
                  resetForm();
                })
                .catch((error) => {
                  resetForm();
                });
            }}
          >
            {(formikProps) => {
              return (
                <Fragment>
                  <Form formikProps={formikProps} />
                </Fragment>
              );
            }}
          </Formik>
        )}
      </Fragment>
    </OuterBox>
  );
};

export default AutoGateOpen;
